import styled, { keyframes, css } from "styled-components";

const shine = keyframes`
  0% {
    transform: translate3d(-100%, 0, 0);
  }
  100% {
    transform: translate3d(100%, 0, 0);
  }
`;

const Skeleton = styled.div`
  overflow: hidden;
  position: relative;
  min-height: 24px;
  max-width: 100%;
  ${css({
    borderRadius: "default",
  })}
  &::after {
    animation-timing-function: ease-in-out;
    animation-iteration-count: infinite;
    animation-name: ${shine};
    animation-duration: 2s;
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-image: linear-gradient(
      90deg,
      rgba(0, 0, 0, 0) 0,
      #8f9bb3 50%,
      rgba(0, 0, 0, 0) 100%
    );
  }
`;
export default Skeleton;
